import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import routesConfig from 'constants/routesConfig.json';
import { usePosthogCapture } from 'auth/posthogCapture/_index';

import ErrorMessage from 'auth/components/ErrorMessage';
import AuthCard from 'auth/components/AuthCard';

import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'auth/styles/Card.style';
import { useLoginMutation } from 'auth/hooks/loginApi';

export default function EnterEmail(): JSX.Element {
  const { mutate: login } = useLoginMutation();
  const { t } = useTranslation('pageLogin');
  const history = useHistory();
  const auth = usePosthogCapture();

  const [email, setEmail] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);

  const submitEmail = useCallback(() => {
    login(
      { email },
      {
        onSuccess: () =>
          history.push({
            pathname: `${routesConfig.ACCESS_CODE_PAGE}`,
            state: { email },
          }),
        onError: (e) => {
          if (e.status === 400) setInvalidEmail(true);
        },
      }
    );
    auth.loginEmailSubmitted();
  }, [login, email, auth, history]);

  const submitDisabled = email.length === 0;

  return (
    <AuthCard heading={t('emailCard.heading')}>
      <Styled.FormInput>
        <Styled.Input
          autoComplete="email"
          autoFocus
          fullWidth
          id="email"
          type="email"
          placeholder={t('emailCard.inputPlaceholder')}
          name="email"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setEmail(event.target.value)
          }
          onKeyDown={(ev: React.KeyboardEvent<HTMLInputElement>) => {
            if (ev.key === 'Enter') {
              if (!submitDisabled) submitEmail();
              ev.preventDefault();
            }
          }}
          value={email}
        />
        <Buttons.Primary
          $size="medium"
          inactive={submitDisabled}
          onClick={submitEmail}
          stretch
        >
          {t('emailCard.submitButtonLabel')}
        </Buttons.Primary>
      </Styled.FormInput>

      {invalidEmail ? <ErrorMessage error="invalid email" /> : null}
    </AuthCard>
  );
}
